import { ReactComponent as LogoSvg } from "./logo.svg";

export const Assets = {
  LogoSvg,
};
